import React from 'react';
import { haptic } from '@/lib/haptics';

interface StaffSelectionModalProps {
  isOpen: boolean;
  onSelect: (staffMember: string) => void;
  onClose?: () => void;
}

const STAFF_MEMBERS = [
  { name: 'Boniswa', initial: 'B', color: 'from-purple-500 to-pink-500' },
  { name: 'Joy', initial: 'J', color: 'from-green-500 to-emerald-500' },
  { name: 'Bryce', initial: 'B', color: 'from-primary to-yellow-500' },
];

export function StaffSelectionModal({ isOpen, onSelect, onClose }: StaffSelectionModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4" style={{ paddingTop: 'max(env(safe-area-inset-top), 80px)' }}>
      <div className="bg-dark border-2 border-primary/30 rounded-2xl p-4 max-w-sm w-full shadow-2xl">
        {/* Header */}
        <div className="flex items-center justify-between mb-3">
          <div className="flex-1">
            <h2 className="text-lg font-bold text-white">
              Who's Working?
            </h2>
            <p className="text-gray-400 text-xs">
              Select your name to track actions
            </p>
          </div>
          {onClose && (
            <button
              onClick={onClose}
              className="w-8 h-8 flex items-center justify-center rounded-full bg-dark-lighter text-gray-400 hover:text-white hover:bg-dark-lighter/80 transition-colors active:scale-95"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          )}
        </div>

        {/* Staff Buttons */}
        <div className="space-y-2">
          {STAFF_MEMBERS.map((staff) => (
            <button
              key={staff.name}
              onClick={() => { haptic.medium(); onSelect(staff.name); }}
              className="w-full group relative overflow-hidden rounded-xl border border-dark-lighter hover:border-primary/50 transition-all duration-200 active:scale-[0.98]"
            >
              <div className="flex items-center gap-3 p-3 bg-dark-lighter/50">
                <div className={`w-10 h-10 rounded-full bg-gradient-to-br ${staff.color} flex items-center justify-center text-white text-base font-bold shadow-lg`}>
                  {staff.initial}
                </div>
                <div className="flex-1 text-left">
                  <div className="text-base font-semibold text-white group-hover:text-primary transition-colors">
                    {staff.name}
                  </div>
                </div>
                <div className="text-gray-600 group-hover:text-primary transition-colors">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </div>
            </button>
          ))}
        </div>

        {/* Footer */}
        <div className="mt-3 text-center text-xs text-gray-600">
          This helps track who performed each action
        </div>
      </div>
    </div>
  );
}
